import { render, staticRenderFns } from "./CreateContentTable.vue?vue&type=template&id=3da07d5a&scoped=true"
import script from "./CreateContentTable.vue?vue&type=script&lang=js"
export * from "./CreateContentTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da07d5a",
  null
  
)

export default component.exports